/* eslint-disable max-len */
import 'react-virtualized/styles.css';
import './css/site.scss';

import App from './components/App/containers/App';

// import { PersistGate } from 'redux-persist/es/integration/react';
import { StylesProvider } from '@material-ui/styles';
import React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { configureStore } from './configureStore';
import * as serviceWorker from './registerServiceWorker';
import { detect } from 'detect-browser';
import ServerMsg from './components/ServerMsg/ServerMsg';
import { AxiosError } from 'axios';
import { SetERAError } from './store/states/Framework/FrameworkActionCreator';
import { eraClient } from './store/states/GenericActionCreator';

const MAX_RETRIES = 1;

function configureAxios(store) {
    eraClient.defaults.headers.common['retryCount'] = 0;

    eraClient.interceptors.response.use(
        response => response,
        (error: AxiosError) => {
            const retryCount = eraClient.defaults.headers.common['retryCount'];

            if (!error.response && error.config && retryCount < MAX_RETRIES) {
                eraClient.defaults.headers.common['retryCount'] += 1;

                // Attempt the retry
                return eraClient(error.config);
            }

            if (!error.response) {
                store.dispatch(SetERAError(error.message ?? 'Network Error'));
            }

            return Promise.reject(error);
        },
    );
}

export default async function renderApp() {
    // Setup the service worker.
    // Currently we are disabling it until we can figure out how to avoid caching issues.
    serviceWorker.unregister();

    // Check for a default state.
    // I don't like this but it will have to do until we can come up with something better.
    const defaultState = (window as any).__REDUX_DEFAULT_STATE__ ?
        (window as any).__REDUX_DEFAULT_STATE__ :
        undefined;

    // Set the name if one doesn't exist.
    if (!window.name) {
        window.name = 'DSCM';
    }

    // Get the application-wide store instance.
    const { store } = await configureStore(defaultState);

    await configureAxios(store);

    let mainDisplay = <></>;
    const browser = detect();
    switch (browser && browser.name) {
        case 'ie':
            mainDisplay = <ServerMsg />;
            break;

        default:
            mainDisplay = <App />;
            break;
    }

    const domElement = (
        <Provider store={store}>
            <StylesProvider >
                <BrowserRouter basename={process.env.HOST_URL}>
                    {mainDisplay}
                </BrowserRouter>
            </StylesProvider>
        </Provider>
    );

    ReactDOM.render(
        domElement,
        document.getElementById('root') as HTMLElement,
    );
}
